import React from "react";
import "@/animations/animate.css";

import Badge from "@/components/ui/badge";
import Image from "next/image";
import AnimatedElements from "@/animations/AnimatedElement";

import StandartText from "./standartText";
// @ts-ignore

const About = ({certificate } : any ) => {
    const [result, setResult] = React.useState<any>(null);
    const [load , setLoad] = React.useState(false);
   

    React.useEffect(() => {
    
        async function getdata() {
       
            
            const siparis = await fetch(`${process.env.NEXT_PUBLIC_URL}/api/siparis?certificate=${certificate}`);

            const havadurumu2 = await siparis.json();
            setLoad(true)
            console.log(havadurumu2)
            setResult(havadurumu2)
        }
    
        getdata();
    
    }
    , [])
return (
<>

    <section
        className="relative h-screen z-10 0 w-full  items-center justify-center overflow-hidden bg-black bg-cover bg-center pt-16 pb-36 md:pt-20 md:pb-44 lg:pt-20 lg:pb-56"
        id="location">

        <div className="mx-auto flex w-[100%] flex-col sm:flex-row items-center justify-center lg:max-w-[1212.8px]">
        {load &&( <>
            <div className="mx-auto flex w-[100%] order-2 sm:order-1 flex-col lg:max-w-[1200px] lg:flex-row lg:gap-20">
                <div
                    className="mb-10 flex w-[100%]  flex-col  items-center justify-start  text-[18px] font-medium  leading-relaxed tracking-wide text-[#e4ded7] md:mb-16  md:text-[20px] md:leading-relaxed lg:mb-16  lg:max-w-[90%] lg:text-[24px] ">

                    <Badge className="w-fit text-black m-0 mb-0 mt-0">
                        Bu konumu hatırlıyor musun? </Badge>
                    <StandartText parallax={1.2} title1="Hatıralar" title2="UNUTULMAZ"
                        desc={result.konumText} />

                </div>
            </div>
            <div className="mx-auto flex w-[100%] order-1 sm:order-2 flex-col lg:max-w-[1200px] lg:flex-row lg:gap-20">
                <div
                    className="mb-10 flex w-[100%] flex-col justify-center items-center gap-4 text-[18px] font-medium  leading-relaxed tracking-wide text-[#e4ded7] md:mb-16 md:gap-6 md:text-[20px] md:leading-relaxed lg:mb-16  lg:max-w-[90%] lg:text-[24px] ">
           <AnimatedElements>
                        <Image src={`https://sertfika.vercel.app/api/konum?enlem=${result.Enlem}&boylam=${result.Boylam}`}
                            alt="Harita" className=" w-80 h-80 rounded-3xl " width={500} height={500} />
                    </AnimatedElements>
                </div>
            </div>
    </> )}   </div>
    </section>
</>
);
};

export default About;